import React, { useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { UserContext } from '../contexts/userContext';
import request from '../services/Request';
import EnterEmail from './enterEmail';
import localRequest from '../services/LocalServer/localRequest';
import IdleEmail from './items/IdleEmail';
import Cookies from 'js-cookie';
import logger from '../services/LocalServer/logger';
import { QRCodeSVG } from 'qrcode.react';
import { sleep } from '../services/methods';

const createOrderURL = `/orders/create`;
const oneTimeStatus = '/promos/status/';

export default function ProductDispense(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { testMode } = useContext(UserContext);
  const { stat, setStat, linkPromo, audio, stopPlay, HFuser, clientUser } = props;
  const machine = JSON.parse(localStorage.getItem('machine'));
  const currency = machine?.currency?.code;
  const qrData = `${localStorage.getItem('MOBILE_URL')}/signup/${machine?.groupCode}`;

  const { receipt, belongTo, name } = machine;

  const { t } = useTranslation();
  let history = useHistory();
  const machineID = props.id;
  const [inv, setInv] = useState(() => {});
  const [failOne, setFailOne] = useState(false);
  const [show, setShow] = useState(false);
  const [inputShow, setInputShow] = useState(false);
  const [door, setDoor] = useState(t('Your items are vending, please wait.'));
  const countRef = useRef(0);
  const [receiptSend, setReceiptSend] = useState(false);
  const [readySend, setReadySend] = useState(false);
  const [orderID, setOrderID] = useState('');
  const [showProduct, setShowProduct] = useState(true);
  const [error, setError] = useState('');
  const [input, setInput] = useState('');
  const [isCheck, setCheck] = useState(true);
  const [messageWidth, setMessageWidth] = useState('78.4%');
  const [go, setGo] = useState(false);
  const [credit, setCredit] = useState(0);
  const [shouldStop, setShouldStop] = useState(false);
  const intervalRef = useRef(null);

  let p = JSON.parse(localStorage.getItem('SeparateItem'));
  let FinalProducts = JSON.parse(localStorage.getItem('FinalProducts'));
  let isBundle = FinalProducts[0]?.itemSold?.length > 0;

  // p = p.filter((e) => e.prodType === 'prod');

  let [FinalTax, setFinalTax] = useState(parseFloat(localStorage.getItem('FinalTax')));
  let [TotalPrice, setTotalPrice] = useState(parseFloat(localStorage.getItem('TotalPrice')));
  const [separateItem, setP] = useState(p);

  //add item_id only when array contain prodtype prod
  const shouldAddItem = separateItem.some((item) => item.prodType === 'prod');
  const initialPods = shouldAddItem ? [...separateItem, { item_id: 0 }] : [...separateItem];
  const [pod, setPods] = useState(initialPods);

  const cartProds = separateItem.map((prod, i) => {
    // console.log(prod);
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    let url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;

    if (prod.prodType === 'fridge1' || prod.prodType === 'fridge2') {
      url = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/fridge/${prod.picture}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    }
    return (
      <div className="payment-product-card" key={i}>
        <img className="card-img" src={url} alt=""></img>
        <div className="payment-card-text">{prod.product_name}</div>
      </div>
    );
  });

  useEffect(() => {
    if (audio?.dispense) {
      audio.dispense.loop = true;
      stopPlay();
      audio.dispense.play();
    }
    if (!testMode) {
      // Clear any existing interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      intervalRef.current = setInterval(() => fetchAPI(), 1000);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, []);

  let onceTake = true;
  let onceSuccess = true;

  async function fetchAPI() {
    if (shouldStop) return;
    const currentItem = pod[countRef.current];
    console.log('currentItem', currentItem);

    // If no more items to process, complete the transaction
    if (countRef.current >= pod.length) {
      await completeTransaction();
      return;
    }

    if (currentItem?.prodType === 'prod' || currentItem?.item_id === 0) {
      await fetchRegularProductAPI();
    } else if (currentItem.prodType === 'fridge1') {
      setDoor(t('Please grab your product at the fridge'));
      countRef.current = countRef.current + 1;
      await sleep(1000);
      //decrease the quantity

      try {
        await localRequest({
          method: 'post',
          url: '/decreaseQtt',
          data: {
            uid: currentItem.product,
          },
        });
      } catch (error) {
        console.log('Error decreasing quantity for fridge1:', error);
      }

      // Check if this was the last item and no regular products exist
      if (countRef.current >= pod.length && !shouldAddItem) {
        await completeTransaction();
      }
    } else if (currentItem.prodType === 'fridge2') {
      setDoor(t('Please grab your product at the shelf'));
      countRef.current = countRef.current + 1;
      await sleep(1000);

      try {
        await localRequest({
          method: 'post',
          url: '/decreaseQtt',
          data: {
            uid: currentItem.product,
          },
        });
      } catch (error) {
        console.log('Error decreasing quantity for fridge1:', error);
      }

      // Check if this was the last item and no regular products exist
      if (countRef.current >= pod.length && !shouldAddItem) {
        await completeTransaction();
      }
    } else if (currentItem.prodType === 'linkedBox') {
      setDoor(t('Please grab your product at the Locker'));
      countRef.current = countRef.current + 1;
      await sleep(1000);
    } else {
      // Skip if prodType doesn't match any expected type
      countRef.current = countRef.current + 1;

      // Check if this was the last item and no regular products exist
      if (countRef.current >= pod.length && !shouldAddItem) {
        await completeTransaction();
      }
    }
  }

  async function fetchRegularProductAPI() {
    logger(2, 'Fetch API with' + pod[countRef.current].item_id);
    await localRequest({
      method: 'get',
      url: `${process.env.REACT_APP_LOCAL_API}/dispenseStatus/${pod[countRef.current].item_id}`,
    }).then(async (status) => {
      if (status.data.status === 'SUCCESS') {
        logger(2, 'Success with' + pod[countRef.current].item_id);
        const index = pod.findIndex((e) => e.item_id === status.data.item_id);
        if (index > -1 && pod[index].status !== 'SUCCESS') {
          console.log('index', index);
          logger(2, 'Find ID');
          pod[index].status = 'SUCCESS';
          setPods([...pod]);
          countRef.current = countRef.current + 1;
          setDoor(t('Your items are vending, please wait.'));
          setMessageWidth('78.4%');
        }
      } else if (status.data.status === 'FAIL') {
        logger(2, 'Failed with' + pod[countRef.current].item_id);
        setFailOne(true);
        const index = pod.findIndex((e) => e.item_id === status.data.item_id);
        if (index > -1 && pod[index].status !== 'FAIL') {
          logger(2, 'Failed found');
          //adjust transaction if failed
          const indexFinal = separateItem.findIndex((e) => e.item_id === status.data.item_id);
          if (indexFinal > -1) {
            separateItem[indexFinal].err = true;
            FinalTax = parseFloat((FinalTax - separateItem[indexFinal].tax_amount).toFixed(2));
            TotalPrice = parseFloat(
              (TotalPrice - separateItem[indexFinal].total_amount).toFixed(2)
            );
            setFinalTax(FinalTax);
            setTotalPrice(TotalPrice);
          }
          pod[index].status = 'FAIL';
          setPods([...pod]);
          countRef.current = countRef.current + 1;
        }
        setDoor(t('Your items are vending, please wait.'));
        setMessageWidth('78.4%');
      } else if (status.data.status === 'CHANGE') {
        logger(2, 'CHANGE with' + pod[countRef.current].item_id);
        setDoor(t('Please collect change'));
        setMessageWidth('82%');
      } else if (status.data.status === 'COMPLETED') {
        logger(2, 'Completed with' + pod[countRef.current].item_id);
        if (onceSuccess && audio?.doorClose) {
          onceSuccess = false;
          stopPlay();
          audio.doorClose.play();
        }
        setCredit(status.data.credit);
        // Call the centralized completion function
        await completeTransaction();
      } else if (status.data.status === 'TAKE') {
        logger(2, 'Take with' + pod[countRef.current].item_id);
        if (onceTake && audio?.doorOpen) {
          onceTake = false;
          stopPlay();
          audio.doorOpen.play();
        }
        setDoor(t('Please grab your product'));
        setMessageWidth('82%');
      } else {
        logger(2, 'nothing with' + status.data.status);
      }
    });
  }

  // New helper function to complete transaction
  async function completeTransaction() {
    console.log('completeTransaction');
    setShouldStop(true);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setShowProduct(true);
    setDoor(t('Thank you for shopping!'));
    setMessageWidth('72.4%');

    await setTimeout(
      () => {
        logger(2, 'setGo Completed');
        setGo(true);
      },
      receiptSend ? 1000 : 5000
    );
  }

  // useEffect(async () => {
  //   if (!testMode) {
  //     let go = pod.every((a) => a.status === 'SUCCESS');
  //     let failGo = pod.every((a) => a.status === 'SUCCESS' || a.status === 'FAIL');
  //     if (go || failGo) {
  //       await clearInterval(inv);
  //       setShowProduct(true);
  //       setDoor(t('Thank you for shopping at TravelWifi Express!'));
  //       setMessageWidth('72.4%');
  //       await setTimeout(
  //         () => {
  //           setGo(true);
  //         },
  //         receiptSend ? 1000 : 5000
  //       );
  //     }
  //   } else {
  //     // history.push(linkToURL + 'true');
  //   }
  // }, [pod]);

  const updateStatus = async () => {
    await localRequest({
      method: 'post',
      url: `${process.env.REACT_APP_LOCAL_API}/updateKioskStatus`,
      data: { status: 'Active' },
    });
  };

  const sendOrder = async () => {
    const mycoockie = Cookies.get('i18next') ? Cookies.get('i18next') : 'en';
    logger(2, 'Send Order Start');
    if (go) {
      if (separateItem?.length > 0) {
        let status = failOne ? 'Failed' : 'Completed';
        //add banner convertion
        console.log('linkPromo', linkPromo);
        if (linkPromo?.id !== '') {
          const conIdx = separateItem.findIndex((e) => e.product === linkPromo?.id);
          if (conIdx > -1) {
            console.log('same');
            stat.banner.conv = 1;
            setStat(stat);
            console.log('stat', stat);
          }
        }
        // add prod conver
        separateItem.forEach((item) => {
          const prodIdx = stat.prod.findIndex((e) => e._id === item.product);
          if (prodIdx > -1) {
            stat.prod[prodIdx].conv += 1;
          }
        });

        console.log('separateItem?', separateItem);
        let date = new Date();
        let realTime = new Date();
        const offset = date.getTimezoneOffset();
        date.setTime(date.getTime() - offset * 60 * 1000);
        const linkToURL = `/machineUI/home/${machineID}/`;
        let payment_type = localStorage.getItem('payment_type');
        let custom = '';

        if (localStorage.getItem('HELLO_FRESH') === 'TRUE') {
          custom = HFuser?.hfid;
          payment_type = 'HF';
        }

        //format clientUser
        if (clientUser?.discount) {
          clientUser.discount_id = clientUser.discount._id;
          clientUser.discount_amount = clientUser.discount?.amount;
        }

        console.log('clientUser in sendorder', clientUser);

        if (isBundle) {
          let allFailed = true;
          //mapseparateItem
          const fpd = separateItem.map((item) => {
            if (!item.err) {
              allFailed = false;
            }
            return {
              name: item.product_name,
              upc: item.upc,
              _id: item.product,
              err: item.err,
              soldPrice: item.soldPrice,
              tax_amount: item.tax_amount,
            };
          });
          FinalProducts[0].bundle_details = fpd;

          if (allFailed) {
            FinalProducts[0].err = true;
          }
        }

        const orderData = {
          clientUser: clientUser,
          machine: machineID,
          products: isBundle ? FinalProducts : separateItem,
          tax: FinalTax,
          belongTo: belongTo,
          total: TotalPrice,
          machineName: name,
          currency: currency,
          createdAt: date,
          realTime: realTime,
          isCheck: isCheck,
          status: status,
          credit: credit,
          email: receiptSend ? input : '',
          payment_type: payment_type,
          id: name + new Date().getTime(),
          lang: mycoockie,
          send_order_third: localStorage.getItem('send_order_third'),
          custom: custom,
        };

        console.log('orderData', orderData);

        await request({
          method: 'post',
          url: createOrderURL,
          data: orderData,
          timeout: 3800,
        })
          .then((res) => {
            console.log('sendorder to remote success', res.data);
            setOrderID(res.data.order._id);
            setReadySend(true);
          })
          .catch(() => {
            console.log('sendorder to local');
            localRequest({
              method: 'post',
              url: createOrderURL,
              data: orderData,
            }).then((res) => {
              console.log('send order to local succcess', res.data);
              setOrderID(res.data?.order?._id);
              setReadySend(true);
            });
          });
      }
      history.push(`/machineUI/slider/${machineID}`);
    }
  };

  useEffect(async () => {
    if (go) {
      if (!testMode) {
        if (!show) {
          await setTimeout(async () => {
            logger(2, 'useEffect go or show debug');
            stat.session_com = 1;
            setStat(stat);
            sendOrder();
          }, 4000);
        }
      } else {
        // history.push(linkToURL + 'true');
      }
    }
  }, [go, show]);

  const setKeyBoardShow = () => {
    logger(2, 'keyboard opened');
    setInputShow(true);
    setShow(true);
  };

  const submitEmail = () => {
    logger(2, 'email input:' + input);
    if (error === '' && input !== '') {
      setReceiptSend(true);
      setTimeout(() => {
        setShow(false);
      }, 100);
    } else {
      const myfocus = document.getElementById('email-enter-input');
      myfocus.focus();
      console.log(myfocus);
    }
    if (input === '') {
      setError(t('Email address can not be empty.'));
    }
  };

  return (
    <div className="payment-container">
      <IdleEmail go={go} sendOrder={sendOrder} />
      <div className="payment-container-div">
        {showProduct && (
          <div>
            {/* <img className="payment-logo-img" src={TW_log} alt=""></img> */}
            <img className="payment-logo-img" alt=""></img>
            <div className="payment-products-container">{cartProds}</div>
            <div className="payment-line"></div>
          </div>
        )}
        {failOne ? (
          <div
            className={showProduct ? 'dispense-title' : 'dispense-title-none'}
            style={{ marginTop: '-40px', fontSize: '60px' }}
          >
            {t(`You will not be charged for products not vended.`)}

            <p style={{ marginTop: '80px' }}>{door}</p>
          </div>
        ) : (
          <div
            className={showProduct ? 'dispense-title' : 'dispense-title-none'}
            style={{ width: messageWidth }}
          >
            {door}
          </div>
        )}

        {machine.mobile && !clientUser?._id && (
          <div>
            <div className="dispense-title mb-5" style={{ fontSize: '30px', marginTop: '20px' }}>
              {t(`Scan the QR code to register for membership`)}
            </div>
            <QRCodeSVG value={qrData} size={256} level={'H'} className="mx-auto" />
          </div>
        )}

        {inputShow && receiptSend ? (
          readySend ? (
            <div className="dispense-get-receipt-text">{t(`Delivering receipt...`)}</div>
          ) : (
            <div className="dispense-get-receipt-text">{t(`Delivering receipt...`)}</div>
          )
        ) : (
          !inputShow &&
          !go &&
          navigator.onLine &&
          receipt && (
            <div className="view-more-button dispense-get-receipt-button" onClick={setKeyBoardShow}>
              {t(`GET RECEIPT`)}
            </div>
          )
        )}
        <EnterEmail
          handleClick={submitEmail}
          isLocal={isLocal}
          isCheck={isCheck}
          setCheck={setCheck}
          receipt={receipt}
          receiptSend={receiptSend}
          langs={props.langs}
          cart={props.cart}
          showProduct={showProduct}
          orderID={orderID}
          readySend={readySend}
          inputShow={inputShow}
          id={machineID}
          testMode={props.testMode}
          show={show}
          setShow={setShow}
          setError={setError}
          error={error}
          input={input}
          setInput={setInput}
          separateItem={separateItem}
        />
        {inputShow && !receiptSend && receipt && (
          <div className="d-flex justify-content-center">
            <div className="view-more-button dispense-get-receipt-button-2" onClick={submitEmail}>
              {t(`GET RECEIPT`)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
